/**
 * Detects whether the app is running as an installed PWA in standalone display mode.
 *
 * Used to gate behaviors that don't work the same inside a standalone PWA window —
 * notably `target="_blank"` on file links, which on iOS can't actually open a new
 * tab and instead navigates the standalone window to the file URL.
 */
export const isStandalonePWA = (): boolean => {
  if (typeof window === 'undefined') return false

  if (window.matchMedia?.('(display-mode: standalone)')?.matches) {
    return true
  }

  // iOS Safari exposes a non-standard `navigator.standalone` for home-screen apps.
  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone
  return iosStandalone === true
}
